import { AnimatePresence } from 'framer-motion';
import { Route, Routes } from 'react-router-dom';

import ForgotPassword from '../pages/ForgotPassword';
import ItensRelations from '../pages/ItensRelations';
import LoginPage from '../pages/Login';
import NotFound from '../pages/NotFound';
import Signup from '../pages/Signup';
import UpdateRegister from '../pages/UpdateRegister';
import ValidateRegister from '../pages/ValidateRegister';

function LoginRoute() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/updateRegister" element={<UpdateRegister />} />
        <Route path="/verification" element={<ValidateRegister />} />
        <Route path="/forgot" element={<ForgotPassword />} />

        <Route path="/itens-relations" element={<ItensRelations />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

export default LoginRoute;
